import {MaxLength, ValidationOptions} from 'class-validator';

export function MyMaxLength(max: number, validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: `Maximum length is ${max} symbols`}, validationOptions);
  return MaxLength(max, options);
}
